import React from "react";
import * as CHQ from "chq";

import { ProfileLink } from "app/links";
import { Trans } from "app/utils";

import NotificationBody from "./NotificationBody";

type InterestsAlignedNotificationProps = {
  notification: CHQ.NotificationInterestsAligned;
  tabIndex?: number;
};

const InterestsAlignedNotification: React.FC<InterestsAlignedNotificationProps> = ({
  notification: { actor, entity }, tabIndex
}) => {
  // For some reason on the API side we're not properly deleting all of these
  // notifications when a user interest gets deleted. This check needs to be
  // here until we fix that.
  if (!entity) {
    return null;
  }

  return (
    <NotificationBody actor={actor}>
      <ProfileLink user={actor} tabIndex={tabIndex || 0} />
      {" "}
      <Trans>has added one of your interests to their profile:</Trans>
      {" "}
      {entity.interest.name}
    </NotificationBody>
  );
};

export default InterestsAlignedNotification;
